import React from 'react'
import { observer } from 'mobx-react-lite'
import useCareerEssaySubmission from './hooks/useCareerEssaySubmission'
import s from './styles/CareerEssaySubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const CareerEssaySubmission = observer(({ assignment, student }) => {
	const { responseText, hasResponse } = useCareerEssaySubmission({
		assignment,
		student,
	})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>
					<div className={sharedStyles.textArea}>
						{hasResponse ? (
							<p className={sharedStyles.textContent}>{responseText}</p>
						) : (
							<div className={sharedStyles.empty}>
								No response submitted yet
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
})

CareerEssaySubmission.displayName = 'CareerEssaySubmission'

export default CareerEssaySubmission
